<script setup>
import { validateGoogleIconName } from '@/constants/googleIconNames'

const props = defineProps({
  name: { type: String, required: true, validator: validateGoogleIconName },
  colour: { type: String, default: "#434343"},
  size: { type: String, default: '24px' },
  filled: { type: Boolean, default: false },
  weight: { type: Number, default: 400 },
  grad: { type: Number, default: 0 },
  opsz: { type: Number, default: 24 },
})

const fontVariationSettings = computed(() => ([
  `'FILL' ${props.filled ? 1 : 0}`,
  `'wght' ${props.weight}`,
  `'GRAD' ${props.grad}`,
  `'opsz' ${props.opsz}`
].join(', ')))
</script>

<template>
  <span
    class="material-symbols-outlined"
    :style="{ fontSize: props.size, color: props.colour, fontVariationSettings }"
  >{{ name }}</span>
</template>
